import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ClipboardModule } from 'ngx-clipboard';
import { ThemeModule } from './../../../@theme/theme.module';
import { PipesModule } from './../../../shared/pipes/pipes.module';
import { TransPipe } from './../../../shared/pipes/trans.pipe';
import { SharedModule } from './../../../shared/shared.module';
import { BrandDragAndDropComponent } from './brand-drag-and-drop/brand-drag-and-drop.component';
import { ChannelDragAndDropComponent } from './channel-drag-and-drop/channel-drag-and-drop.component';
import { DealerDragAndDropComponent } from './dealer-drag-and-drop/dealer-drag-and-drop.component';
import { DragAndDropBaseComponent } from './drag-and-drop-base-component/drag-and-drop-base.component';
import { LeadTypeDragAndDropComponent } from './lead-type-drag-and-drop/lead-type-drag-and-drop.component';
import { UsersDragAndDropComponent } from './users-drag-and-drop/users-drag-and-drop.component';

@NgModule({
    declarations: [
        DragAndDropBaseComponent,
        UsersDragAndDropComponent,
        LeadTypeDragAndDropComponent,
        DealerDragAndDropComponent,
        ChannelDragAndDropComponent,
        BrandDragAndDropComponent,
    ],
    imports: [
        A11yModule,
        ClipboardModule,
        CdkStepperModule,
        CdkTableModule,
        CdkTreeModule,
        DragDropModule,
        CommonModule,
        SharedModule.forChild(),
        PipesModule,
        FormsModule,
        ThemeModule,
    ],
    exports: [
        A11yModule,
        ClipboardModule,
        CdkStepperModule,
        CdkTableModule,
        CdkTreeModule,
        DragDropModule,
        DragAndDropBaseComponent,
        UsersDragAndDropComponent,
        LeadTypeDragAndDropComponent,
        DealerDragAndDropComponent,
        ChannelDragAndDropComponent,
        BrandDragAndDropComponent,
    ],
    providers: [TransPipe]
})
export class DragAndDropModule { }
